import React from "react";

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { 
      hasError: false,
      errObj: undefined,
     };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true, errObj: error };
  }

  componentDidCatch(error, errorInfo) {
    // You can also log the error to an error reporting service
    console.log (error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      // render fallback UI
      return (
        <>
        <h1>Something went wrong.</h1>
        <h2>Details {this.state.errObj}</h2>
        </>
      )
    }
    return this.props.children; 
  }
}